import { useEffect, useState } from 'react';
import { IPeriod, prePeriodGeneric } from './interface';
import {
  fixMinMaxForDatePicker,
  formatDate,
  formatPeriod,
  getDateWithoutTimezone,
} from '../utils/date-helper';

interface IUseSelectPeriod {
  preSelectedPeriod: prePeriodGeneric | undefined;
  onChangePeriod: (period: string) => void;
  minStartDate?: string | number;
  maxEndDate?: string | number;
}

export const useSelectPeriod = ({
  preSelectedPeriod,
  onChangePeriod,
  minStartDate,
  maxEndDate,
}: IUseSelectPeriod) => {
  const [period, setPeriod] = useState<IPeriod>({
    type: 'otimo',
  });

  const isCustomOrMonths =
    period?.type === 'CUSTOM' || period?.type === 'MONTHS';

  const onSelectPeriod = (period: IPeriod) => {
    if (period?.type === 'CUSTOM') {
      const startDate = getDateWithoutTimezone(period?.startDate!, {
        defaultDate: minStartDate,
      }) as number;
      const endDate = getDateWithoutTimezone(period?.endDate!, {
        defaultDate: maxEndDate,
      }) as number;

      onChangePeriod(`${startDate} - ${endDate}`);

      setPeriod({
        ...period,
        startDate: fixMinMaxForDatePicker(startDate)!,
        endDate: fixMinMaxForDatePicker(endDate)!,
      });

      return;
    }

    onChangePeriod(period?.value!);
    setPeriod(period);
  };

  const formatPeriodMessage = (): string => {
    if (period?.type === 'CUSTOM') {
      return `${formatDate(period?.startDate as string)} - ${formatDate(
        period?.endDate as string
      )}`;
    } else if (period?.type === 'MONTHS') {
      return `${period?.value} meses`;
    }
    return '';
  };

  useEffect(() => {
    const formatedPeriod = formatPeriod(preSelectedPeriod);
    setPeriod(formatedPeriod)
  }, [preSelectedPeriod])

  return {
    period,
    onSelectPeriod,
    formatPeriodMessage,
    isCustomOrMonths,
  };
};
